<form id="autonomo-identificacion" class="row form-identification-styles first-container-identification-xs m-t-34 m-t-xs-40 m-b-29 form-width-size"  [formGroup]="form" (ngSubmit)="saveStepOne($event)" autocomplete="off">
  <div class="  col-12 m-b-36 d-flex justify-content-between align-items-start">
    <div class="container-return-style align-self-start">
      <img class="img-return-blue" [src]="url_img.return_blue" alt="" (click)="previous('I')">
    </div>
    <app-header-steps></app-header-steps>
  </div>
  <div class="col-12 m-b-20">
    <div class="">
      <div class="d-block w-100">
        <p class=" heading-b-b-26 text-start line-height-33 text-start line-height-20 text-start mb-0">
          Identificación oficial
        </p>
      </div>
    </div>
  </div>

  <div class="col-12 m-b-40 container-bottom-dynamic" [ngClass]="{'input-error-style': typeIDRadio.invalid && typeIDRadio.touched }">
      <p class="paragraph-b-r-16 text-start line-height-20 m-b-12">
        Tipo
      </p>
      <div class="form-check form-check-inline radio-style-form radio-repet-bottom" *ngFor="let item of idTypesRadio">
        <label class="form-check-label radio-content " for="radio_identification_{{item.type}}">
          <span class="first-letter-capitalize">{{item.text}}</span> 
          <input class="form-check-input" type="radio" formControlName="radio_identification" id="radio_identification_{{item.type}}" [value]="item.type" (change)="setValidationId()">
          <span class="checkmark"></span>
        </label>
      </div>      
      <div [ngClass]="{'input-error-style': typeIDSelect.invalid && typeIDSelect.touched }">
        <div class="form-check form-check-inline radio-style-form m-b-5">
          <label class="form-check-label radio-content " for="radio_identification2">
            <select class="paragraph-b-r-16 select-field-style width-240" formControlName="select_identification" (change)="setTypeIDSelect()">
              <option value="">Elige otro</option>
              <option *ngFor="let item of idTypesSelect" [value]="item.type">{{item.text | titlecase}}</option>
            </select>
            <!--?Nuevo select para verlo regresar a d-block la clase d-none-->
            <div ngbDropdown class="button-dropdown-style d-none w-240">
              <div class="button-generic-style button-outline button-drop-style text-start width-240 height-40 d-flex justify-content-between align-items-center p-y-11" id="dropdownBasic1" ngbDropdownToggle> 
                <span>Elige otro</span> <img class="img-arrowdown-blue" [src]="url_img.arrowdown_blue" alt="">
              </div>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-container-style">                
                <button ngbDropdownItem>Another Action</button>
                <button ngbDropdownItem>Something else is here</button>
              </div>
            </div>
            <input class="form-check-input" type="radio" formControlName="radio_identification" id="radio_identification2" value="0" (change)="setValidationId()">
            <span class="checkmark top-10"></span>
          </label>
        </div>
        <p class="text-error-style d-flex align-items-center" *ngIf="typeIDRadio.invalid && typeIDRadio.touched">
          <img class="circle-error-tomato" [src]="url_img.alert" alt="">Elige una opción para continuar
        </p>
        <p class="text-error-style d-flex align-items-center" *ngIf="typeIDSelect.invalid && typeIDSelect.touched">
          <img class="circle-error-tomato" [src]="url_img.alert" alt="">Elige una opción para continuar
        </p>
      </div>
  </div>

  <div class="col-12 m-b-40" [hidden]="showRadioFiles">
    <div [ngClass]="{'input-error-style': numberFilesRadio.invalid && numberFilesRadio.touched }">
      <p class=" paragraph-b-r-16 text-start line-height-20 m-b-16">
        ¿Cómo capturaste tu identificación?
      </p>
      <div class="form-check form-check-inline radio-style-form m-b-16">
        <label class="form-check-label radio-content " for="number_files1">Tengo dos imágenes (una por cada lado)
          <input class="form-check-input" type="radio" formControlName="number_files" id="number_files1" value="2" (ngModelChange)="setValidationFile()">
          <span class="checkmark"></span>
        </label>
      </div>
      <br>
      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="number_files2">Tengo una imagen que muestra ambos lados
          <input class="form-check-input" type="radio" formControlName="number_files" id="number_files2" value="1" (ngModelChange)="setValidationFile()">
          <span class="checkmark"></span>
        </label>
      </div>
      <p class="text-error-style d-flex align-items-center" *ngIf="numberFilesRadio.invalid && numberFilesRadio.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">Elige una opción para continuar
      </p>
    </div>
  </div>

  <div class="w-100 d-block"></div>

  <div class="col-12 m-b-20">

    <p class=" paragraph-b-r-16 text-start line-height-20 m-b-26" [hidden]="!showRadioFiles">
      Adjunta una imagen de tu identificación. El archivo debe ser PNG, JPG o PDF y pesar menos de 5MB
    </p>
    <p class=" paragraph-b-r-16 text-start line-height-20 m-b-26" [hidden]="showFileText('2')">
      Adjunta una imagen de cada lado de tu identificación. Cada archivo debe ser PNG, JPG o PDF y pesar menos de 5 MB
    </p>
    <p class=" paragraph-b-r-16 text-start line-height-20 m-b-26" [hidden]="showFileText('1')">
      Adjunta una imagen que incluya ambos lados de tu identificación. Debe ser PNG, JPG o PDF y pesar menos de 5 MB
    </p>

    <div [ngClass]="{'input-error-style': invalidSizeOne || invalidExtOne || invalidNameFileOne || msgErrorFileOne!=''}">
      <div class="input-dropzone-style width-200 " [ngClass]="{'m-b-12': !invalidSizeOne && !invalidExtOne || !invalidNameFileOne || msgErrorFileOne==''}" [hidden]="showInputsFiles('1')">
        <input type="file" class="form-control input-custom-file" formControlName="file_one" #file_one (change)="uploadFileId($event,1)" accept=".png,.jpg,.pdf">
        <p class="text-dropzone-style">
          {{file_text}}
        </p>
      </div>
      <p class="text-error-style d-flex align-items-center" *ngIf="invalidSizeOne">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">El archivo debe pesar menos de 5MB
      </p>
      <p class="text-error-style d-flex align-items-center" *ngIf="invalidExtOne">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">El archivo debe ser PNG, JPG o PDF
      </p>
      <p class="text-error-style d-flex align-items-center" *ngIf="invalidNameFileOne">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">El nombre del archivo deber ser menor a 50 caracteres
      </p>
      <p class="text-error-style d-flex align-items-center" *ngIf="msgErrorFileOne!=''">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">{{msgErrorFileOne}}
      </p>
    </div>
    
    <div [hidden]="showIDImgFront()">
      <div class="container-photo-style m-b-5" [hidden]="showImgPDF('img', '1')">
        <img class="img-id-front" [src]="dataIdentificacion.img_file_one" alt="">
        <img class="img-arrows-white" [src]="url_img.arrows_white" alt="" (click)="openModalFront(content)">
      </div>

      <div class="container-pdf-style m-b-12" [hidden]="showImgPDF('pdf', '1')">
        <img class="img-pdf-blue" [src]="url_img.pdf_blue" alt=""><span class="text-pdf-blue p-l-10"><span class="">{{dataIdentificacion.cx_nombre_identificacion}}</span></span>
      </div>

      <a class="link-generic-style line-height-20 m-b-12 d-block" href="javascript:void(0)" (click)="file_one.click()">Reemplazar</a>
    </div>

    <div [ngClass]="{'input-error-style': invalidSizetwo || invalidExtTwo || invalidNameFileTwo || msgErrorFileTwo!=''}">
      <div class="input-dropzone-style width-200 m-b-20" [ngClass]="{'m-b-12': !invalidSizetwo && !invalidExtTwo || !invalidNameFileTwo}" [hidden]="showInputsFiles('2')">
        <input type="file" class="form-control input-custom-file" formControlName="file_two" #file_two (change)="uploadFileId($event,2)" accept=".png,.jpg,.pdf">
        <p class="text-dropzone-style">
          Seleccionar reverso
        </p>
      </div>

      <p class="text-error-style d-flex align-items-center" *ngIf="invalidSizetwo">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">El archivo debe pesar menos de 5MB
      </p>
      <p class="text-error-style d-flex align-items-center" *ngIf="invalidExtTwo">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">El archivo debe ser PNG, JPG o PDF
      </p>
      <p class="text-error-style d-flex align-items-center" *ngIf="invalidNameFileTwo">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">El nombre del archivo deber ser menor a 50 caracteres
      </p>
      <p class="text-error-style d-flex align-items-center" *ngIf="msgErrorFileTwo!=''">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">{{msgErrorFileTwo}}
      </p>
    </div>
    
    <div [hidden]="showIDImgReverse()">
      <div class="container-photo-style m-b-12" [hidden]="showImgPDF('img', '2')">
        <img class="img-id-front" [src]="dataIdentificacion.img_file_two" alt="">
        <img class="img-arrows-white" [src]="url_img.arrows_white" alt="" (click)="openModalReverse(content)">
      </div>

      <div class="container-pdf-style m-b-12 p-t-5" [hidden]="showImgPDF('pdf', '2')">
        <img class="img-pdf-blue" [src]="url_img.pdf_blue" alt=""><span class="text-pdf-blue p-l-10"><span class="">{{dataIdentificacion.cx_nombre_rfc}}</span></span>
      </div>

      <a class="link-generic-style  line-height-20 m-b-12 d-block" href="javascript:void(0)" (click)="file_two.click()">Reemplazar</a>
    </div>             
    
  </div>

  <div class="col-12 m-b-40">
    <div [ngClass]="{'input-error-style': proofAddressInput.invalid && proofAddressInput.touched }">
      <p class=" paragraph-b-r-16 text-start line-height-20 m-b-16">
        ¿La foto de tu identificación muestra tu domicilio actual al frente?
      </p>

      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="proof_address1">Sí
          <input class="form-check-input" type="radio" formControlName="proof_address" id="proof_address1" value="1">
          <span class="checkmark"></span>
        </label>
      </div>      
      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="proof_address2">No
          <input class="form-check-input" type="radio" formControlName="proof_address" id="proof_address2" value="0">
          <span class="checkmark"></span>
        </label>
      </div>

      <p class="text-error-style d-flex align-items-center" *ngIf="proofAddressInput.invalid && proofAddressInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">Elige una opción para continuar
      </p>
    </div>
  </div>

  <div class="col-6  text-start">
    <div class="m-b-29">
      <button class="button-generic-style button-outline height-48 w-100" (click)="previous('')">Regresar</button>
    </div>
  </div>
  <div class="col-6  text-end">
    <div class="m-b-29">
      <button class="button-generic-style button-blue height-48 w-100" type="submit" [disabled]="(form.invalid && proofAddressInput.invalid) || !dataIdentificacion.cx_tipo_identificacion.length || !dataIdentificacion.cx_contenido_identificacion.length" >Continuar</button>

    </div>
  </div>
</form>

<ng-template #content let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Close')">
      <img class="img-close-blue" [src]="url_img.close_blue" alt="">
    </button>
  </div>
  <div class="modal-body text-center">
    <img class="img-fluid" [src]="imgModal" alt="">
  </div>
</ng-template>
